export enum OngoingABTests {
    USP_LISTING_TILE = "rp-tile-usp",
    PROPERTY_FAQ = "rp_faq_property_page",
    DSA_RATING_SORT = "algorytmic_listing_sort",
    UNLOCK_CHOICE = "rp-after-register-choice",
    REGISTRATION_WIZARD = "rp-registration-wizard",
    FAVOURITES_TOPBAR = "rp-favourites-topbar"
}
export enum OngoingABTests {
    USP_LISTING_TILE = "rp-tile-usp",
    PROPERTY_FAQ = "rp_faq_property_page",
    DSA_RATING_SORT = "algorytmic_listing_sort",
    UNLOCK_CHOICE = "rp-after-register-choice",
    REGISTRATION_WIZARD = "rp-registration-wizard",
    FAVOURITES_TOPBAR = "rp-favourites-topbar"
}
